const events = {};

export function trackOnce(eventName: string) {
  if (events[eventName]) {
    return;
  }
  events[eventName] = true;
  track(eventName);
}

export function track(eventName: string) {
  gtag('event', eventName);
  piwik('trackEvent', eventName);
}
